import { render } from "./Companies.vue?vue&type=template&id=56af4c79&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"

import "./Companies.vue?vue&type=style&index=0&id=56af4c79&lang=css"
import "./Companies.vue?vue&type=style&index=1&id=56af4c79&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56af4c79"]])

export default __exports__